export const route = {
  home: '/',
  notFound: '/404',
  office: '/atelier',
  works: '/realisations',
  legals: '/mentions-legales',
  mobilier: '/mobilier',
  contact: '/contact',
};
